import React from 'react';
import styled from 'styled-components';

import UsageSummaryPane from '../../containers/usage/UsageSummaryPane';
import UsageMainPane from '../../containers/usage/UsageMainPane';
import docsBookmarks from '../../constants/docs';
import DocsLink from '../docs/DocsLink';
import NavigationBar from '../navigation/NavigationBar';
import SpinnerWithButton from '../common/SpinnerWithButton';

const StyledUsageViewContainer = styled.div`
  height: calc(100% - 63px);
  overflow-y: auto;

  .usage-container {
    display: flex;
    flex-direction: column;
    padding: 20px;
    height: 100%;

    .usage-header {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }
  }
`;

const UsageView = ({
  executing,
  onExecute,
  extraActions,
  onRequestCancel,
  cancelButtonDisabled,
}) => (
  <>
    <NavigationBar onExecute={onExecute} executeDisabled={executing} extraActions={extraActions} />
    <StyledUsageViewContainer>
      <div className="usage-container">
        <div className="usage-header">
          <h2 style={{ margin: 0 }}>Usage</h2>
          <DocsLink
            scrolTo={docsBookmarks.usage}
            styleIcon={{ fontSize: 20, margin: 5, color: 'gray' }}
          />
        </div>
        <UsageSummaryPane />
        <SpinnerWithButton
          onClick={onRequestCancel}
          disabled={cancelButtonDisabled}
          executing={executing}
        >
          <UsageMainPane />
        </SpinnerWithButton>
      </div>
    </StyledUsageViewContainer>
  </>
);

export default UsageView;
